const API_BASE_URL = "https://server.gsneotek.cloud";
const API_PYTHON_URL = "https://server.gsneotek.cloud"; // Exposed via ALB path routing (/reservations/*)

export { API_BASE_URL, API_PYTHON_URL };
export default API_BASE_URL; // Default export for backward compatibility if needed
